"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectListWithRelation = void 0;
const complex_data_1 = require("complex-data");
class SelectListWithRelation extends complex_data_1.SelectList {
    getRelation(value, offset = 1, prop = 'value') {
        const item = this.getItem(value, prop);
        if (this.miss === item) {
            return undefined;
        }
        else {
            const index = this.list.indexOf(item);
            return this.getIndex(index + offset);
        }
    }
    getIndex(index) {
        return this.list[index];
    }
}
exports.SelectListWithRelation = SelectListWithRelation;
